<template>
  <help-info-wrapper :info.sync="helpData" :service-name="serviceName" class="warp">

     <v-card class="mb-1 modern-list-item rounded-lg elevation-2 hover-elevation"
  :style="{ borderLeft: `5px solid ${borderColorHex} !important` }"
  :class="expireCardClass"
  :color="info.color ? (info.color === 'green' ? '#44ff002e' : '#ffa5003d') : null" 
  outlined 
  hover>      
      <div class="pa-3 position-relative" 
      role="button" tabindex="0"
       @click.stop="toggleDetails" @keydown.enter.stop="toggleDetails"
        @keydown.space.prevent.stop="toggleDetails"
       :class="{'disabled': !!info?.data?.data?.auto_id}">
        

                <v-row no-gutters align="center">
          
            <v-col cols="12" sm="4" md="3" class="d-flex align-center justify-space-between justify-sm-end order-1 order-sm-3 mb-4 mb-sm-0 px-2 px-sm-0" style="gap: 12px;"> 
            <div class="header-cell renew-cell d-flex justify-center flex-grow-1 flex-sm-grow-0" @click.stop v-if="!showExpanded">

              <renew-button 
                class="responsive-renew-btn"
                :badge-text="renewBadgeText" 
                :badge-color="renewBadgeColor" 
                :button-color="renewButtonColor" 
                :loading="priceLoading" 
                :scale="0.66" 
                @click="getPrices" 
                :badgeOffsetY="14.8" 
                :buttonText="$t('assistantChatViewer.renew')" 
              />
            </div>

                <v-btn
                  v-if="$vuetify.breakpoint.smAndDown"
                  icon
                  @click.stop.prevent="toggleDetails"
                  :loading="isLoadingDetails"
                >
                  <v-icon color="grey darken-2">
                    {{ showExpanded ? 'mdi-close' : 'mdi-dots-vertical' }}
                  </v-icon>
                </v-btn>

                <v-btn 
                  v-if="$vuetify.breakpoint.mdAndUp"
                  depressed 
                  :outlined="!showExpanded" 
                  :color="showExpanded ? 'primary' : 'grey darken-2'" 
                  small 
                  @click.stop.prevent="toggleDetails" 
                  :loading="isLoadingDetails" 
                  class="rounded-lg py-5 px-2 mx-2"
                >
                  <v-icon small v-if="!showExpanded">mdi-cog-outline</v-icon>
                  <span class="px-2">{{ showExpanded ? $t('assistantChatViewer.close') : $t('manageDiscount.manage') }}</span>
                  <v-icon right>{{ showExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>


          </v-col>

          <v-col cols="12" sm="5" md="4" class="order-2 order-sm-1 mb-3 mb-sm-0 pt-2 pt-sm-0">
            <v-row no-gutters align="center">
              
              <v-col cols="12" sm="auto" class="d-flex align-center mb-2 mb-sm-0">
                <v-checkbox @click.stop v-model="checkbox" color="primary" dense hide-details class="ma-0 mr-2" />                
                <!-- qr thumb -->
                <div class="header-cell thumb-cell" v-if="!showExpanded">                   
                     <v-card elevation="2" class="qr-thumb-wrap pa-1 rounded-lg white position-relative d-flex justify-center flex-column align-center">
                <v-tooltip v-if="(!info.img_url || !info.image)" top>
                  <template v-slot:activator="{ on, attr }">
                    <v-btn  
                    :href="['qrLink','clickyarseo'].includes(info.type) ? `#/qr/design2/${!!info.qrId ? info.qrId : ''}` : `#/qr/design/${info?.domain?.name}${!!info.identifier ? info.identifier : ''}`" 
                    class="rounded-lg px-0 ma-1" color="warning" depressed min-width="60" width="60" height="60" target="_blank" v-bind="attr" v-on="on">
                      <v-icon x-large>mdi-image-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("regenerate_image") }}</span>
                </v-tooltip>

                <div v-if="!(info.extra_short && info.extra_short.id && (!info.img_url || !info.image))" class="img-wrapper position-relative d-inline-block">
                  <div v-if="isImageLoading && imageLoadingFromParent" class="nfc-loading-overlay" style="position: absolute; top:0; left:0; right:0; bottom:0; background:rgba(255,255,255,0.9); display:flex; align-items:center; justify-content:center; border-radius:8px; z-index:10;">
                    <div class="text-center"> 
                      <v-progress-circular color="primary" indeterminate size="40" width="3"></v-progress-circular>
                      <div class="mt-2 text-grey-darken-1">{{ $t("updating_qr") }}</div>
                    </div>
                  </div>
                  <v-img :lazy-src="getImage" :src="getImage" :style="{ borderTop: `0px solid ${borderColorHex} !important`,borderRight: `0px solid ${borderColorHex} !important` }"
                    width="60" height="60" contain class="rounded-lg qr-thumb" eager @error="onImageError" @loaded="onImageLoad">
                    <template v-slot:placeholder>
                      <v-row align="center" class="fill-height ma-0" justify="center">
                        <v-progress-circular v-if="isImageLoading && !imageLoadingFromParent" color="primary" indeterminate size="32" width="3"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </v-card>
                </div>
                
                <!-- آیکون نوع -->
            <div class="me-3 d-flex align-center justify-center rounded-lg gradient-border-wrapper ml-3" >
              <div class="inner-icon-box rounded-lg pa-6" :style="{ background: fadedGradientStyle }" >
                
                <v-badge
                  v-if="$options.filters.qrType(info.type, 'pro')"
                  color="transparent"
                  overlap
                  offset-x="18"
                  offset-y="7"
                >
                  <template #badge>
                    <v-icon class="gradient-icon" :style="{ backgroundImage: gradientStyle }" size="13" >mdi-crown</v-icon>
                  </template>

                  <img 
                    v-if="displayMap[info.type] && displayMap[info.type].type === 'image'" 
                    :src="displayMap[info.type].src" 
                    width="30" 
                    height="30" 
                    contain
                  />
                  <v-icon 
                    v-else 
                    class="gradient-icon" 
                    :style="{ backgroundImage: gradientStyle }" 
                    size="30"
                  >mdi-{{ info.type | qrType("icon") }}</v-icon>
                </v-badge>

                <template v-else>
                  <img 
                    v-if="displayMap[info.type] && displayMap[info.type].type === 'image'" 
                    :src="displayMap[info.type].src" 
                    width="30" 
                    height="30" 
                    contain
                  />
                  <v-icon 
                    v-else 
                    class="gradient-icon" 
                    :style="{ backgroundImage: gradientStyle }" 
                    size="30"
                  >mdi-{{ info.type | qrType("icon") }}</v-icon>
                </template>

              </div>
            </div>

              </v-col>

              <v-col cols="12" sm="auto" class="d-flex flex-column px-2 px-sm-3 mt-1 mt-sm-0" :class="{ 'pr-10': $vuetify.breakpoint.xs }">
                <div v-if="!editTitle" class="d-flex align-center font-size-h6">
                 <span 
                 class="font-size-h6 font-weight-bold main-qr-title d-inline-block text-truncate" 
                 style="max-width: 100px !important; vertical-align: middle !important; color:grey">{{ info.title }}</span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon x-small @click.stop="editTitle = true" class="ms-1" color="grey darken-1">
                      <v-icon small>mdi-rename-box-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>تغییر نام</span>
                  </v-tooltip>
                </div>
              <v-text-field 
                v-else 
                v-model="editedName" 
                v-click-outside="onCloseField" 
                :disabled="permissionState.edit_name" 
                :error-messages="errorMessage" 
                :hide-details="!errorMessage" 
                :loading="loading" 
                dense 
                outlined 
                clearable 
                append-icon="mdi-check" 
                class="edit-field-small" 
                @click.stop="" 
                @click:append="updateTitle" 
                @click:clear="onCloseField" 
                @keydown.enter="updateTitle" 
              />
                
               <div class="text-caption mt-2 font-weight-bold d-flex flex-row align-center" :style="(displayMap[info.type] && displayMap[info.type].type === 'image') ? { color: '#757575' } : { backgroundImage: gradientStyle, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', color: 'transparent' }">
  
  <!-- حالت دارای تگ PRO -->
  <v-badge
    color="transparent"
    overlap
    offset-x="14"
    offset-y="8"
    x-small 
    v-if="$vuetify.breakpoint.smAndUp && $options.filters.qrType(info.type, 'pro')"
  >
    <template #badge>
      <v-icon class="gradient-icon" :style="{ backgroundImage: gradientStyle }" size="8" >mdi-crown</v-icon>
    </template>
    
    <img 
      v-if="displayMap[info.type] && displayMap[info.type].type === 'image'" 
      :src="displayMap[info.type].src" 
      width="14" 
      height="14" 
      class="ml-1"
      style="object-fit: contain;"
    />
    <v-icon v-else class="gradient-icon" :style="{ backgroundImage: gradientStyle }" x-small>mdi-{{ info.type | qrType("icon") }}</v-icon>
  </v-badge>

  <!-- حالت معمولی (بدون PRO) -->
  <template v-if="$vuetify.breakpoint.smAndUp && !$options.filters.qrType(info.type, 'pro')">
    <img 
      v-if="displayMap[info.type] && displayMap[info.type].type === 'image'" 
      :src="displayMap[info.type].src" 
      width="14" 
      height="14" 
      class="ml-1"
      style="object-fit: contain;"
    />
    <v-icon v-else class="gradient-icon" :style="{ backgroundImage: gradientStyle }" x-small>mdi-{{ info.type | qrType("icon") }}</v-icon>                 
  </template>

  <!-- اولویت نام با displayMap تنظیم شد -->
  <span>
    {{ (displayMap[info.type] && displayMap[info.type].name) ? displayMap[info.type].name : $options.filters.qrType(info.type, 'name') }}
  </span>
</div>

              </v-col>

            </v-row>
          </v-col>

          <!-- وسط: لینک اصلی -->
          <v-col cols="12" sm="4" md="5" class="d-flex justify-center align-center mb-3 mb-md-0 order-3 order-sm-2" dir="ltr" > 
            <v-chip  v-if="!!displayLink && displayLink?.trim()!==''"
              class="px-0 py-3 rounded-lg custom-link-chip" 
              :style="$vuetify.breakpoint.smAndDown?'width:100%':''"
            >
              <v-icon left small class="px-3" color="#042FC8">mdi-link-variant</v-icon>
              <v-tooltip v-model="showTooltip" color="green darken-1" top>
                <template v-slot:activator="{ attrs }">
                  <a  :href="validHref" 
                      target="_blank" 
                      class="d-inline-block text-truncate text-decoration-none" 
                      style="max-width: 120px !important; color: #042FC8; font-weight: bold; vertical-align: middle;"
                      @click.stop v-bind="attrs" >
                    {{ displayLink }}
                  </a>
                </template>
                <span>{{ $t("copied") }}</span>
              </v-tooltip>
              <v-btn icon small @click.stop="copyUrl" class="ms-2 pl-6 pr-3" color="#042FC8">
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </v-chip>
          </v-col>

        </v-row>

      </div>
      <!-- وضعیت اتوماتیک (پراگرس) -->
      <div v-if="!!info?.data?.data?.auto_id && info?.data?.data?.auto_id !== null" class="px-4 w-100">
        <v-divider class="mb-3" />
        <progress_createauto :info="info" />
      </div>

      <!-- ========================================== -->
      <!-- بخش بازشو: تمام عملیات‌ها، تصویر و آمار -->
      <!-- ========================================== -->
      <v-expand-transition>
        <div v-if="showExpanded" class="grey lighten-5">
          <v-divider></v-divider>
  
                   <v-row class="pa-5 pt-3" align="stretch">

            <!-- ۱. ترتیب موبایل: دکمه تمدید -->
            <v-col cols="12" class="d-md-none order-1 pb-0 mb-3">
              <renew-button class="py-2 w-100" :badge-text="renewBadgeText" :badge-color="renewBadgeColor" :button-color="renewButtonColor" :scale="0.75" :loading="priceLoading" @click="getPrices" :badgeOffsetY="14.8" :buttonText="$t('assistantChatViewer.renew')" />
            </v-col>

            <!-- ۲. تصویر کیوآر کد (سمت راست در دسکتاپ - RTL) -->
            <v-col cols="12" md="3" class="d-flex justify-center align-center order-2 order-md-1 mb-4 mb-md-0">
              <v-card elevation="2" class="pa-2 rounded-lg white position-relative d-flex justify-center flex-column align-center">
                <v-tooltip v-if="(!info.img_url || !info.image)" top>
                  <template v-slot:activator="{ on, attr }">
                    <v-btn :href="['qrLink','clickyarseo'].includes(info.type) ? `#/qr/design2/${!!info.qrId ? info.qrId : ''}` : `#/qr/design/${info?.domain?.name}${!!info.identifier ? info.identifier : ''}`" class="rounded-lg px-0 mt-2" color="warning" depressed min-width="112" target="_blank" v-bind="attr" v-on="on">
                      <v-icon>mdi-image-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("regenerate_image") }}</span>
                </v-tooltip>

                <div v-if="!(info.extra_short && info.extra_short.id && (!info.img_url || !info.image))" class="img-wrapper position-relative d-inline-block">
                  <div v-if="isImageLoading && imageLoadingFromParent" class="nfc-loading-overlay" style="position: absolute; top:0; left:0; right:0; bottom:0; background:rgba(255,255,255,0.9); display:flex; align-items:center; justify-content:center; border-radius:8px; z-index:10;">
                    <div class="text-center"> 
                      <v-progress-circular color="primary" indeterminate size="40" width="3"></v-progress-circular>
                      <div class="mt-2 text-grey-darken-1">{{ $t("updating_qr") }}</div>
                    </div>
                  </div>
                  <v-img :lazy-src="getImage" :src="getImage" :max-height="isMobile ? '230' : '210'" :max-width="isMobile ? '155' : '210'" :min-width="isMobile ? '155' : '210'" contain eager @error="onImageError" @loaded="onImageLoad">
                    <template v-slot:placeholder>
                      <v-row align="center" class="fill-height ma-0" justify="center">
                        <v-progress-circular v-if="isImageLoading && !imageLoadingFromParent" color="primary" indeterminate size="32" width="3"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </v-card>
            </v-col>

<!-- آمار و تاریخ -->
<v-col cols="12" md="2" class="mt-2 d-flex flex-column justify-space-between order-5 order-md-2" style="color:black">
  <div class="d-none d-md-flex flex-column status-dates grey--text text--lighten-3 mb-2 text-md-left text-center">
    <v-tooltip top>
      <template v-slot:activator="{ on, attr }">
        <div class="d-flex align-center mb-1" v-bind="attr" v-on="on">
          <v-icon small color="grey" class="ml-1">mdi-calendar-clock</v-icon>
          <span :style="['fa', 'ar', 'ar_ae', 'ar_iq'].includes(exportLang)?'text-align:right':'text-align:left'" style="color:black !important">{{$t('created_at')}}: {{ info.created_at_diff }}</span>
        </div>
      </template>
      <span style="font-size: 0.8em;">{{ dateString(info.created_at) }}</span>
    </v-tooltip>

    <v-tooltip top v-if="info.updated_at_diff">
      <template v-slot:activator="{ on, attr }">
        <div class="d-flex align-center" v-bind="attr" v-on="on">
          <v-icon small color="grey" class="ml-1">mdi-history</v-icon>
          <span :style="['fa', 'ar', 'ar_ae', 'ar_iq'].includes(exportLang)?'text-align:right':'text-align:left'" style="color:black !important">{{$t('last_edit')}}: {{ info.updated_at_diff }}</span>
        </div>
      </template>
      <span style="font-size: 0.8em;">{{ dateString(info.updated_at) }}</span>
    </v-tooltip>

    <!-- آمار بازدید -->
    <div class="text-center my-4 mx-auto" >
      <div class="font-weight-black primary--text mb-1 text-h4" style="line-height: 1;">
        {{ info.clicks || 0 | persianNum }}
      </div>
      <div class="grey--text text--darken-2 mt-2">{{$t('visits')}}</div>
    </div>
  </div>
</v-col>
            <!-- ۴. ابزارهای مدیریت در قالب گرید (سمت چپ در دسکتاپ) -->
            <v-col cols="12" md="7" class="d-flex flex-column order-4 order-md-3 mt-md-2" :class="{'disabled': !!info?.data?.data?.auto_id && info?.data?.data?.auto_id !== null}">
              <div class=" grey--text text--darken-1 mb-2 d-none d-md-flex align-center">
                <v-icon small class="ml-1" color="grey">mdi-tune-vertical</v-icon> {{$t('toolsManagment')}}
              </div>
               <!-- گرید ابزارها -->
              <v-sheet class="pa-2 rounded-lg"  style="background-color: #f8f9fa; border: 1px solid #e9ecef; min-width: 200px;">
                <div class="tools-grid-container">
                  
                <router-link v-if="permissionState.edit_info || !['qr.name.productPro', 'qr.name.id.productPro', 'qr.name.id.editPdf', 'qr.name.editPdf'].includes($route.name)" 
                 class="text-decoration-none tool-btn rounded-lg v-btn v-btn--outlined theme--light v-size--default deep-orange--text" 
                      style="text-decoration: none; display: flex;"
                     :to="{ path: cardEditRoute }"
>
                    <v-btn color="pink" text class="rounded-lg w-100 h-100" :title="$t('edit')">
                      <v-icon>mdi-pencil</v-icon>
                      <span class="tool-label">{{ $t("edit") }}</span>
                    </v-btn>
                  </router-link>

                  <v-btn color="red" class="tool-btn rounded-lg" outlined :disabled="permissionState.edit_design" @click.stop="goto(['qrLink','clickyarseo'].includes(info.type) ? `qr/design2/${!!info.qrId ? info.qrId : ''}` : `qr/design/${info.domain.name}${!!info.identifier ? info.identifier : ''}`)" :title="$t('design')">
                    <v-icon>mdi-palette</v-icon>
                    <span class="tool-label">{{ $t("design") }}</span>
                  </v-btn>

                  <v-btn v-if="info.status === 'active'" color="grey darken-3" :disabled="permissionState.edit_settings" class="tool-btn rounded-lg" outlined @click.stop="['qrLink','clickyarseo'].includes(info.type) ? goto(`qr/setting2/${info.qrId}`) : goto(`qr/setting/${info.domain.name}${!!info.identifier ? info.identifier : ''}`)" :title="$t('qr_settings')">
                    <v-icon>mdi-cogs</v-icon>
                    <span class="tool-label">{{ $t("qr_settings") }}</span>
                  </v-btn>

                  <v-btn v-if="info.status === 'active'" color="warning" :disabled="permissionState.toggle_access" class="tool-btn rounded-lg" outlined @click.stop="showPause('deactivate')" :title="$t('deactivate')">
                    <v-icon>mdi-pause</v-icon>
                    <span class="tool-label">{{ $t("deactivate") }}</span>
                  </v-btn>

                  <v-btn color="primary" class="tool-btn rounded-lg" outlined @click.stop="$emit('print-qr', info)" :title="$t('print_qr')">
                    <v-icon>mdi-printer-outline</v-icon>
                    <span class="tool-label">{{ $t("print_qr") }}</span>
                  </v-btn>

                  <v-btn v-if="['VisitCard','visitcardpro'].includes(info.type)" color="info" :href="gotoGraphic" class="tool-btn rounded-lg" outlined target="_blank" :title="$t('print_visit_card')">
                    <v-icon>mdi-card-account-phone-outline</v-icon>
                    <span class="tool-label">{{ $t("print_visit_card") }}</span>
                  </v-btn>

                  <v-btn :href="qrSmsLink" color="deep-purple" class="tool-btn rounded-lg" outlined target="_blank" :title="$t('send_link')">
                    <v-icon>mdi-cellphone-message</v-icon>
                    <span class="tool-label">{{ $t("send_link") }}</span>
                  </v-btn>

                  <v-btn v-if="['wheel'].includes(info?.type?.toLowerCase())" color="amber darken-2" class="tool-btn rounded-lg" outlined @click.stop="$emit('show', { info: info, type: 'wheel_winner_list' })" :title="$t('winner_list')">
                    <v-icon>mdi-trophy</v-icon>
                    <span class="tool-label">{{ $t("winner_list") }}</span>
                  </v-btn>
                    <!-- ۱. دکمه لیست پرسنل -->
                    <v-btn
                      v-if="['attendanceqr'].includes(info?.type?.toLowerCase())"
                      color="primary"
                      class="tool-btn rounded-lg"
                      outlined
                      @click.stop="$emit('show', { info: info, type: 'employee_list' })"
                      :title="'لیست پرسنل'"
                    >
                      <v-icon>mdi-account-group-outline</v-icon>
                      <span class="tool-label">{{ "لیست پرسنل" }}</span>
                    </v-btn>

                    <!-- ۲. دکمه لیست تردد -->
                    <v-btn
                      v-if="['attendanceqr'].includes(info?.type?.toLowerCase())"
                      color="info"
                      class="tool-btn rounded-lg"
                      outlined
                      @click.stop="$emit('show', { info: info, type: 'attendace_list' })"
                      :title="'تردد روزانه'"
                    >
                      <v-icon>mdi-clipboard-clock-outline</v-icon>
                      <span class="tool-label">{{ "تردد روزانه" }}</span>
                    </v-btn>

                    <!-- ۳. دکمه خروجی اکسل -->
                    <v-btn
                      v-if="['attendanceqr'].includes(info?.type?.toLowerCase())"
                      color="success"
                      class="tool-btn rounded-lg"
                      outlined
                      :loading="downLoading"
                      :disabled="downLoading"
                      @click.stop="downloadExcel"
                      :title="'خروجی اکسل'"
                    >
                      <v-icon>mdi-file-excel-outline</v-icon>
                      <span class="tool-label">{{ $t("export_excel") || "خروجی اکسل" }}</span>
                    </v-btn>

                  <v-btn v-if="['menu', 'appointment', 'bshop', 'wheel', 'multicard'].includes(info?.type?.toLowerCase())" color="indigo" :disabled="permissionState.view_customers" class="tool-btn rounded-lg" outlined @click.stop="$emit('show', { info: info, type: 'users' })" :title="$t('customer_list')">
                    <v-icon>mdi-account-outline</v-icon>
                    <span class="tool-label">{{ $t("customer_list") }}</span>
                  </v-btn>

                  <v-btn v-if="['menu', 'bshop'].includes(info?.type?.toLowerCase())" color="light-green darken-2" :disabled="permissionState.view_orders" class="tool-btn rounded-lg" outlined @click.stop="$emit('show', { info, type: 'orders' })" :title="$t('order_list')">
                    <v-icon>mdi-basket-outline</v-icon>
                    <span class="tool-label">{{ $t("order_list") }}</span>
                  </v-btn>

                  <v-btn v-if="info.type === 'appointment'" color="teal" class="tool-btn rounded-lg" outlined @click.stop="$emit('show', { info, type: 'appointments' })" :title="$t('reserved_appointments')">
                    <v-icon>mdi-calendar-multiple-check</v-icon>
                    <span class="tool-label">{{ $t("reserved_appointments") }}</span>
                  </v-btn>

                  <v-btn v-if="['menu', 'insurance', 'appointment', 'cshop', 'bshop', 'commericial', 'business', 'labelproduct', 'feedbackgallery', 'productpro','visitcardpro'].includes(info?.type?.toLowerCase())" color="cyan darken-2" class="tool-btn rounded-lg" outlined @click.stop="$emit('show', { info, type: 'feedback' })" :title="$t('feedback')">
                    <v-icon>mdi-reply-outline</v-icon>
                    <span class="tool-label">{{ $t("feedback") }}</span>
                  </v-btn>

                  <v-btn v-if="info?.type?.toLowerCase() === 'multicard'" color="blue-grey" class="tool-btn rounded-lg" outlined @click.stop="$emit('show', { info, type: 'transactions' })" title="تراکنش ها">
                    <v-icon>mdi-bank</v-icon>
                    <span class="tool-label">تراکنش ها</span>
                  </v-btn>

                  <v-btn v-if="['menu', 'photogallery', 'insurance', 'appointment', 'cshop', 'commericial', 'VisitCard','visitcardpro', 'bshop', 'business', 'labelproduct', 'consultationqr', 'productpro'].includes(info?.type?.toLowerCase())" color="orange" class="tool-btn rounded-lg" outlined @click.stop="$emit('show', { info, type: 'form' })" :title="$t('request_form')">
                    <v-icon>mdi-list-box-outline</v-icon>
                    <span class="tool-label">{{ $t("request_form") }}</span>
                  </v-btn>

                  <v-btn v-if="info?.type?.toLowerCase() !== 'multicard'" color="brown" :disabled="permissionState.qr_id" class="tool-btn rounded-lg" outlined @click.stop="$emit('show', { info, type: 'ownership' })" :title="$t('transfer_ownership')">
                    <v-icon>mdi-account-key-outline</v-icon>
                    <span class="tool-label">{{ $t("transfer_ownership") }}</span>
                  </v-btn>

                  <v-btn v-if="info.type === 'bShop'" color="purple" class="tool-btn rounded-lg" outlined @click.stop="bshop_mang_pop = true" :title="$t('store_management')">
                    <v-icon>mdi-store</v-icon>
                    <span class="tool-label">{{ $t("store_management") }}</span>
                  </v-btn>

                  <v-btn v-if="choseNfc()" color="deep-orange" class="tool-btn rounded-lg" outlined @click.stop="$emit('show', { info, type: 'nfc' })" :title="$t('select_nfc_card')">
                    <v-icon>mdi-nfc</v-icon>
                    <span class="tool-label">{{ $t("select_nfc_card") }}</span>
                  </v-btn>


                  <v-btn v-else color="success" :disabled="permissionState.toggle_access" class="tool-btn rounded-lg" outlined @click.stop="showPause('active')" :title="$t('activate')">
                    <v-icon>mdi-reload</v-icon>
                    <span class="tool-label">{{ $t("activate") }}</span>
                  </v-btn>

                </div>
              </v-sheet>

             <!-- دکمه‌های عملیاتی پایین ستون ابزارها -->
            <v-row class="mt-auto mb-0 mx-0 pt-3 align-items-end" dense>
              
     <!-- دکمه مشاهده آمار (در موبایل و دسکتاپ نمایان است) -->
              <v-col cols="12" md="4" class="px-1">
                <v-btn color="#00145a" depressed dark block height="40" class="rounded-lg" @click.stop="['qrLink','clickyarseo'].includes(info.type) ? goto(`qr/statistics2/${info.qrId}`) : goto(`qr/statistics/${info.domain.name}${!!info.identifier ? info.identifier : ''}`)">
                  <v-icon left small>mdi-chart-bar</v-icon> {{ $t('view_details') }} 
                </v-btn>
              </v-col>

              <!-- دکمه دانلود (در موبایل و دسکتاپ نمایان است) -->
              <v-col cols="12" md="4" class="px-1 mb-2 mb-md-0">
                <v-btn color="primary" outlined block class="bg-white rounded-lg" height="40" @click.stop="$root.$emit('fillInfo', info)">
                  <v-icon left small>mdi-download</v-icon> {{ $t('download') }}
                </v-btn>
              </v-col>

              <v-col cols="12" md="4" class="d-none d-md-block px-1">
                <renew-button class="w-100" style="height: 40px;" :badge-text="renewBadgeText" :badge-color="renewBadgeColor" :button-color="renewButtonColor" :scale="0.75" :loading="priceLoading" @click="getPrices" :badgeOffsetY="14.8" :buttonText="$t('assistantChatViewer.renew')" />
              </v-col>
         
            </v-row>

             
            </v-col>

            <!-- ۵. ترتیب موبایل: تاریخ‌ها (نمایش فقط در موبایل) -->
            <v-col cols="12" class="d-md-none order-3 d-flex justify-space-between align-center grey--text text--darken-1 mb-4 px-4">
              <div class="d-flex align-center">
                <v-icon small color="grey" class="ml-1">mdi-calendar-clock</v-icon>
                <span :style="['fa', 'ar', 'ar_ae', 'ar_iq'].includes(exportLang)?'text-align:right':'text-align:left'" >{{$t('created_at')}}: {{ info.created_at_diff }}</span>
              </div>
              <div class="d-flex align-center" v-if="info.updated_at_diff">
                <v-icon small color="grey" class="ml-1" >mdi-history</v-icon>
                <span :style="['fa', 'ar', 'ar_ae', 'ar_iq'].includes(exportLang)?'text-align:right':'text-align:left'" >{{$t('last_edit')}}: {{ info.updated_at_diff }}</span>
              </div>
            </v-col>

          </v-row>

        </div>
      </v-expand-transition>
      
    </v-card>
    <custom-popup v-model="bshop_mang_pop" :cons="{ title: $t('manage_products') }" hide-confirm hide-overlay max-width="900" transition="dialog-bottom-transition">
      <v-card class="px-5 py-4">
        <v-row no-gutters>
          <v-col cols="12">
            <v-alert border="left" color="success" colored-border elevation="2">
              <v-btn :loading="downloadLoading" class="text-break" color="success" text @click.stop="downloadProducts">
                <v-icon color="success" right>mdi-download</v-icon> {{ $t("products_export") }}
              </v-btn>
            </v-alert>
          </v-col>
          <v-col class="mt-4" cols="12">
            <v-card id="uploader" ref="uploader" class="mx-auto d-flex justify-center align-center rounded-lg flex-column overflow-hidden" height="200" outlined @click.stop="dragEvent" @dragleave="dragEvent" @dragover="dragEvent" @drop="dragEvent">
              <v-icon size="68" style="opacity: 0.4">mdi-cloud-upload-outline</v-icon>
              <v-card-title class="justify-center">{{ $t("UPLOAD_EXCEL.UPLOAD_TITLE") }}</v-card-title>
              <v-card-text class="text-center pt-0 text-break">
                {{ $t("UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1") }}
                <v-btn class="mx-1" color="primary" min-width="75" small>{{ $t("UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2") }}</v-btn>
                {{ $t("UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3") }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="mt-3" cols="12">
            <v-card v-show="!!filesPreview && !!filesPreview.length" :loading="upLoading" class="mx-auto pa-2 rounded-lg" flat outlined>
              <div v-for="(item, i) in filesPreview" :key="i" class="pa-1 text-center">
                <v-list-item>
                  <v-list-item-avatar :color="item.color || 'success'" class="white--text" size="64"><v-icon>mdi-{{ !!item.color ? !!item.status ? "check" : "close" : "check" }}</v-icon></v-list-item-avatar>
                  <v-list-item-content><v-list-item-title>{{ item.name }}</v-list-item-title></v-list-item-content>
                  <v-list-item-action>
                    <div v-if="!upLoading && (!item.status || !item.color)" class="text-left fill-height"><v-btn icon @click.stop="removeFileFromUpload"><v-icon>mdi-delete</v-icon></v-btn></div>
                  </v-list-item-action>
                </v-list-item>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-card-actions class="justify-end mt-4">
          <v-btn :disabled="!excelFile" :loading="upLoading" color="primary" depressed @click.stop="sendFile">{{ $t("GENERAL.SUBMIT") }}</v-btn>
          <v-btn color="error" text @click.stop="bshop_mang_pop = false">{{ $t("GENERAL.CANCEL") }}</v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import { mapGetters, mapActions } from "vuex";
import progress_createauto from "../../../robot/autoCard/progress_createauto.vue";
import renewButton from "../../../qrland/components/renewButton.vue";
import { ir } from "../../../../../check_domain_ir";
import Vuetify from "vuetify/lib";

export default {
  name: "cardListUser",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    progress_createauto,
    renewButton,
  },

  props: {
    localInfo:Object,
    showCheck: Boolean,
    value: Boolean,
    priceLoading: Boolean,
    imageLoadingFromParent: Boolean,
  },

  data: () => ({
    downLoading:false,
     displayMap: {
        'qreitaa': { type: 'image', src: '/media/socialnetwork/icon/eitaa.webp' ,name:"ایتا"},
        'qrbale': { type: 'image', src: '/media/socialnetwork/icon/bale.webp' ,name:"بله"},
        'qrrobika': { type: 'image', src: '/media/socialnetwork/icon/robika.webp' ,name:"روبیکا"}
      },
    imageHasError:false,
    info: {},
    showExpanded: false, 
    isLoading:false,
    isLoadingDetails: false,
    downloadLoading: false,
    bshop_mang_pop: false,
    excelFile: null,
    filesPreview: [],
    upLoading: false,
    downloadSampleUrl: "/assets/xlsx/products_template.xlsx",
    helpData: [],
    imageKey: 0,
    serviceName: "Qrland",
    componentName: "cardlistuser",
    editTitle: false,
    editedName: "",
    errorMessage: null,
    showTooltip: false,
    loading: false,
    pickedUser: null,
    permissions: null,
    imageLoading: true,
  }),

  mounted() {
    this.info= { ...this.localInfo };
    this.editedName = this.localInfo?.title;
    this.$nextTick(() => {
      this.setCreatedQrID(this.localInfo?.id);
      });
  },
     
 
  computed: {
    expireCardClass() {
    if (!this.getExpireAt) return '';
    try {
      const until = this.$options.filters.untilExpire(this.getExpireAt);
      return this.$options.filters.expireColor(until) || '';
    } catch (e) {
      return '';
    }
  },
    cardEditRoute() {
        if (!this.info) return '';
        return this.findEditPage(this.info?.domain?.name, this.info.identifier, this.info.type, this.info.qrId);
  },
  checkbox: {
  get() {
    return this.value;
  },
  set(val) {
    this.$emit("input", val);
  }},
    permissionState() {
    const permissions = this.permissions || {};

    return {
      editDesign: !permissions.edit_design,
      editInfo: !permissions.edit_info,
      editSettings: !permissions.edit_settings,
      toggleAccess: !permissions.toggle_access,
      viewCustomers: !permissions.view_customers,
      viewOrders: !permissions.view_orders,
      qrId: permissions.qr_id !== this.info.id,
      edit_name: !permissions.edit_name,
      edit_link: !permissions.edit_link,
    };
  },
    validHref() {
    let link = this.info?.dest_link ?? this.qrLink;
    
    if (!link) return '#';

    if (!/^https?:\/\//i.test(link)) {
      return `https://${link}`;
    }
    
    return link;
  },
  gradientStyle() {
  const faded = this.qrGradientColors.colors;
    const Color1 = faded[0] ; 
  const Color2 = (faded[1] || faded[0]) ;
  
  return `linear-gradient(45deg, ${Color1}, ${Color2})`;
},

  fadedGradientStyle() {
  const faded = this.qrGradientColors.fadedcolors;
  const fadedColor1 = faded[0] ; 
  const fadedColor2 = (faded[1] || faded[0]) ;
  
  return `linear-gradient(45deg, ${fadedColor1}, ${fadedColor2})`;
},
    qrGradientColors() {
  const allCategories = [
    {
      name: this.$t("categories.personal_company_website"),
      value: "Business",
      route: "qr.bPage",
      colors: ["#3674B5", "#A1E3F9", "#578FCA07"],
      fadedcolors: ["#3674B533", "#A1E3F933", "#578FCA33"],
      icon: "mdi-store",
    },
    {
      name: this.$t("categories.online_store"),
      value: "bShop",
      route: "qr.bShop",
      colors: ["#3A0519", "#A53860", "#670D2F"],
      fadedcolors: ["#3A051933", "#A5386033", "#670D2F33"],
      icon: "mdi-storefront",
    },
    {
      name: this.$t("categories.online_menu"),
      value: "menu",
      route: "qr.menu",
      colors: ["#3E3232", "#7E6363", "#503C3C"],
      fadedcolors: ["#3E323233", "#7E636333", "#503C3C33"],
      icon: "mdi-silverware",
      testTxt: this.$t("categories.version_three"),
    },
    {
      name: this.$t("categories.appointment_booking"),
      value: "appointment",
      route: "qr.appointment",
      colors: ["#7E6363", "#9B86BD", "#7776B3"],
      fadedcolors: ["#7E636333", "#9B86BD33", "#7776B333"],
      icon: "mdi-calendar-month",
    },
    {
      name: this.$t("categories.commercial_admin_website"),
      value: "Commericial",
      route: "qr.cPage",
      colors: ["#006A71", "#9ACBD0", "#48A6A7"],
      fadedcolors: ["#006A7133", "#9ACBD033", "#48A6A733"],
      icon: "mdi-office-building",
    },
    {
      name: this.$t("categories.online_insurance_sales"),
      value: "insurance",
      route: "qr.insurance",
      colors: ["#8C0000", "#BD2000", "#FA1E0E"],
      fadedcolors: ["#8C000033", "#BD200033", "#FA1E0E33"],
      icon: "mdi-shield-account-outline",
    },
    {
      name: "مولتی کارت",
      value: "multicard",
      route: "qr.card",
      colors: ["#21ff08", "#7df661", "#21ff08"],
      fadedcolors: ["#21ff0833", "#7df66133", "#21ff0833"],
      icon: "mdi-credit-card-multiple",
      comingSoon: false,
    },
    {
      name: this.$t("categories.catalog"),
      value: "catalog",
      route: "qr.catalog",
      colors: ["#0093E9", "#80D0C7", "#0093E9"],
      fadedcolors: ["#0093E933", "#80D0C733", "#0093E933"],
      icon: "mdi-notebook",
    },
    {
      name: this.$t("categories.product_introduction"),
      value: "singleProduct",
      route: "qr.product.shop",
      colors: ["#09122C", "#BE3144", "#872341"],
      fadedcolors: ["#09122C33", "#BE314433", "#87234133"],
      icon: "mdi-archive-check",
    },
    {
      name: "معرفی محصول پرو",
      value: "productpro",
      route: "qr.product.productPro",
      colors: ["#490101", "#C9A44F", "#750404"],
      fadedcolors: ["#49010133", "#C9A44F33", "#75040433"],
      icon: "mdi-professional-hexagon",
    },
    {
      name: this.$t("categories.product_label"),
      value: "labelproduct",
      route: "qr.product.label",
      colors: ["#220E24", "#5454C5", "#342056"],
      fadedcolors: ["#220E2433", "#5454C533", "#34205633"],
      icon: "mdi-tag-multiple",
    },
    {
      name: this.$t("categories.gold_label"),
      value: "goldLabel",
      route: "qr.gold.label",
      colors: ["#957541", "#FCCF5B", "#BE9639"],
      fadedcolors: ["#95754133", "#FCCF5B33", "#BE963933"],
      icon: "mdi-gold",
    },
    {
      name: this.$t("categories.electronic_business_card"),
      value: "visitCard",
      route: "qr.cardVisit",
      colors: ["#FF8008", "#FFC837", "#FF8008"],
      fadedcolors: ["#FF800833", "#FFC83733", "#FF800833"],
      icon: "mdi-card-account-details-outline",
    },
    {
          name: this.$t("categories.electronic_business_card_pro"),
          value: "visitcardpro",
          route: "qr.cardVisitPro",
          colors: ["#F8983E", "#BC9942", "#B9712D"],
          fadedcolors: ["#F7AD6933", "#F8D06B33", "#FC963733"],
          icon: "mdi-card-account-details-outline",
          pro:true,
    },
    {
      name: this.$t("categories.social_media"),
      value: "SocialMedia",
      route: "qr.socialMedia",
      colors: ["#1E6F5C", "#29BB89", "#289672"],
      fadedcolors: ["#1E6F5C33", "#29BB8933", "#28967233"],
      icon: "mdi-instagram",
    },
    {
      name: this.$t("categories.photo_gallery"),
      value: "PhotoGallery",
      route: "qr.photo",
      colors: ["#27374D", "#9DB2BF", "#526D82"],
      fadedcolors: ["#27374D33", "#9DB2BF33", "#526D8233"],
      icon: "mdi-image-area",
    },
    {
      name: this.$t("categories.video_gallery"),
      value: "VideoGallery",
      route: "qr.video",
      colors: ["#EE91E9", "#8ED2C7", "#EE98E9"],
      fadedcolors: ["#EE91E933", "#8ED2C733", "#EE98E933"],
      icon: "mdi-image-area",
    },
    {
      name: this.$t("categories.link"),
      value: "qrlink",
      route: "qr.link",
      colors: ["#410445", "#EAE4D5", "#D76C82"],
      fadedcolors: ["#41044533", "#EAE4D533", "#D76C8233"],
      icon: "mdi-link-variant-plus",
    },
    {
      name: this.$t("categories.link_pro"),
      value: "clickyarseo",
      route: "qr.linkPro",
      colors: ["#453404", "#EAE4D5", "#C9D76C"],
      fadedcolors: ["#CAD31633", "#A0E13833", "#77D76C33"],
      icon: "mdi-link-variant",
      pro:true
    },
    {
      name: this.$t("categories.audio_gallery"),
      value: "voiceGallery",
      route: "qr.voice",
      colors: ["#2B0F0F", "#2c3e50", "#593333"],
      fadedcolors: ["#2B0F0F33", "#2c3e5033", "#59333333"],
      icon: "mdi-folder-play",
    },
    {
      name: this.$t("categories.audio_gallery_pro"),
      value: "voiceGalleryPro",
      route: "qr.voicePro",
      colors: ["#610C9F", "#DA0C81", "#940B92"],
      fadedcolors: ["#610C9F33", "#DA0C8133", "#940B9233"],
      icon: "mdi-folder-play-outline",
    },
    {
      name: this.$t("categories.feedback"),
      value: "feedbackGallery",
      route: "qr.feedback",
      colors: ["#EB5A3C", "#FFCDB2", "#E5989B"],
      fadedcolors: ["#EB5A3C33", "#FFCDB233", "#E5989B33"],
      icon: "mdi-comment-quote",
    },
    {
      name: this.$t("categories.consultation_form"),
      value: "consultationQr",
      route: "qr.consultationQr",
      colors: ["#A87676", "#E1ACAC", "#CA8787"],
      fadedcolors: ["#A8767633", "#E1ACAC33", "#CA878733"],
      icon: "mdi-list-box-outline",
    },
    {
      name: this.$t("categories.application"),
      value: "application",
      route: "qr.application",
      colors: ["#000000", "#253900", "#08CB00"],
      fadedcolors: ["#00000033", "#25390033", "#08CB0033"],
      icon: "mdi-application-braces-outline",
    },
    {
      name: this.$t("categories.luck_wheel"),
      value: "wheel",
      route: "qr.luckWheel",
      colors: ["#A72703", "#FCB53B", "#FFE797"],
      fadedcolors: ["#A7270333", "#FCB53B33", "#FFE79733"],
      icon: "mdi-clover-outline",
    },
    {
      name: this.$t("categories.pdf_gallery"),
      value: "pdfGallery",
      route: "qr.pdf",
      colors: ["#93291E", "#ED213A", "#93291E"],
      fadedcolors: ["#93291E33", "#ED213A33", "#93291E33"],
      icon: "mdi-file-pdf-box",
    },
     {
      name: this.$t("categories.gift"),
      value: "gift",
      route: "qr.gift",
      colors: ["#8A151B", "#E3242B", "#99592A"],
      fadedcolors: ["#8A151B33", "#E3242B33", "#99592A33"],
      icon: "mdi-hand-heart-outline",
    },
        {
      name: this.$t("categories.text"),
      value: "text",
      route: "qr.Qrtext",
      colors: ["#0B132B", "#1C3D5A", "#06B6D4"],
      fadedcolors: ["#0B132B33", "#1C3D5A33", "#06B6D433"],
      icon: "mdi-card-text-outline",
    },
    {
          name: "بله",
          value: "",
          route: "qr.bale", 
          colors: ["#4CD6AE", "#3D9196", "#324A7D"],
          fadedcolors: ["#4CD6AE33", "#3D919633", "#324A7D33"],
          image: "/media/socialnetwork/icon/bale.webp", 
          status: "deactive",

        },
        {
          name: "روبیکا",
          value: "",
          route: "qr.robika", 
          colors: ["#7c25c7", "#E45153", "#F4AA32"],
          image: "/media/socialnetwork/icon/robika.webp", 
          fadedcolors: ["#7c25c733", "#E4515333", "#F4AA3233"],
        },
        {
          name: "ایتا",
          value: "",
          route: "qr.eitaa", 
          colors: ["#B84C24", "#fa8945", "#F05E28"],
          fadedcolors: ["#B84C2433", "#fa894533", "#F05E2833"],
          image: "/media/socialnetwork/icon/eitaa.webp",

        },
         {
          value: "bankcard",
          name: "کیوکارت",
          route: "qr.bankcards", 
          icon: "mdi-credit-card-outline", // یا mdi-bank-outline
          colors: ["#1A237E", "#303F9F", "#E8EAF6"],
          fadedcolors: ["#00020D33", "#242C6C33", "#B1BDFE33"],
          pro: false,
          status: "active",
        },
         {
            name: "لیبل قیمت",
            value: "pricelabel",
            route: "qr.price.label",
            colors: ["#423E03", "#B5A707", "#F4CE46"],
            fadedcolors: ["#423E0333", "#B5A70733", "#F4CE4633"],
            icon: "mdi-cash-multiple",
    },
      {
        name: "حضور و غیاب",
        value: "attendanceqr",
        route: "qr.attendance",
        icon: "mdi-account-check",
        colors: ["#0284C7", "#10B981", "#D1FAE5"],
        fadedcolors: ["#0284C733", "#10B98133", "#D1FAE533"],
      },

  ];

  const currentCategory = allCategories.find(c => c.value?.trim()?.toLowerCase().includes(this.info?.type?.toLowerCase()));
  
  return currentCategory 
    ? { colors: currentCategory.colors, fadedcolors: currentCategory.fadedcolors } 
    : { colors: ["#eeeeee", "#eeeeee"], fadedcolors: ["#eeeeee", "#eeeeee"] };
},

  
    daysRemaining() {
      return this.getUntilExpire(this.getExpireAt);
    },

    renewBadgeText() {
      return this.getTypeText(this.daysRemaining, true);
    },
 borderColorHex() {
    const colorMap = {
      "green darken-1": "#43A047",
      "amber darken-2": "#FFA000",
      "amber darken-3": "#FF8F00",
      "red darken-2": "#D32F2F",
    };
    
    return colorMap[this.renewButtonColor] || "#D32F2F";
  },
    renewButtonColor() {
      const colorClass = this.$options.filters.expireColor(this.daysRemaining);
      const colorMap = {
        "": "green darken-1",
        "in-month": "amber darken-2",
        "in-days": "amber darken-3",
        "in-expire": "red darken-2",
      };
      return colorMap[colorClass] || "red darken-2";
    },

    renewBadgeColor() {
      const colorClass = this.$options.filters.expireColor(this.daysRemaining);
      const colorMap = {
        "": "green darken-2",
        "in-month": "amber darken-3",
        "in-days": "orange lighten-1",
        "in-expire": "red darken-3",
      };
      return colorMap[colorClass] || "red darken-2";
    },
    authToken() {
      return localStorage.getItem("id_token");
    },
    exportLang() {
      return this.$i18n.locale;
    },
    ...mapGetters("ribbon", ["user"]),
    isImageLoading() {
      return this.imageLoadingFromParent || this.imageLoading;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    qrLink() {
      let link = this.info.domain?.name || "";
      let token = localStorage.getItem("id_token");
      if (!link.startsWith("http")) {
        link = "https://" + link;
      }

      if (!!this.info?.identifier) return link + this.info.identifier;
      return link;
    },
    qrSmsLink() {
      let user = this.user?.name ?? "";
      let link = "";

      if (this.user?.family) user += " " + this.user.family;
      if (this.info.domain?.name)
        link = this.info.domain.name + this.info.identifier ?? "";

      let token = localStorage.getItem("id_token");

      let patternId = "";
      switch (this.info.type) {
        case "VisitCard":
        case "Visitcardpro":
          patternId = 244;
          break;
        case "menu":
          patternId = 246;
          break;
        default:
          patternId = 467;
          break;
      }

      return `${this.$services[2]}/?token=${token}#/patternSms?link=${link}&pattern=${patternId}&user=${user}`;
    },
    displayLink() {
      let rgx = /^(http|https):\/\//gm;
      return this.info?.dest_link?? this.qrLink.split("?")[0].replace(rgx, "");
    },
    gotoGraphic() {
      let token = localStorage.getItem("id_token");
      return `${this.$services[14]}/?token=${token}#/visit/card`;
    },
    getExpireAt() {
      return this.info.expire_at;
    },
    getImage() {
      return this.info.img_url === null
        ? (this.$rootUrl || this.$qrUrl + "/") + `qr/${this.info.image}`
        : ir(this.info.img_url);
    },
  },

  watch: {
    "info.title"(val) {
      if (val !== this.editedName) {
      this.editedName = val;
      }
    },
    "info.img_url": {
        handler(newVal, oldVal) {
          if (newVal && newVal !== oldVal) {
            this.imageLoading = true;
            const img = new Image();
            img.src = this.getImage;
            img.onload = () => { this.imageLoading = false; };
            img.onerror = () => {
              this.imageLoading = false;
              this.imageHasError = true;
            };
          }
        }
      },
    showTooltip(val) {
      if (val) {
        setTimeout(() => {
          this.showTooltip = false;
        }, 2000);
      }
    },
    editTitle(val) {
      if (val) {
        this.editedName = this.info.title;
      }
    },
    imageLoadingFromParent(val) {
      this.imageLoading = val;
    },
// localInfo: {
//   deep: true,
//   handler(val) {
//     if (val && !this.isLoadingDetails && !this.info?._detailsLoaded) {
//       if (JSON.stringify(val) !== JSON.stringify(this.info)) {
//         this.info = JSON.parse(JSON.stringify(val));
//       }
//     }
//   }
// }  
},

  methods: {
        ...mapActions("local", [
      "updateQrId",
      "updateQridentifier",
      "updateQrInfo",
      "updateQrDomain",
    ]),

    ...mapActions("localstorage", [
      "setCreatedQrID",
      "setQrType",
      "setRegisterOnline",
    ]),
    downloadExcel(){
      this.$toast.warning("به زودی");
    },
 async toggleDetails(event) {
  if (event && typeof event.stopPropagation === 'function') {
    event.stopPropagation();
  }

  if (this.isLoadingDetails) return;

  if (this.info && this.info._detailsLoaded) {
    this.showExpanded = !this.showExpanded;
    return;
  }

  this.isLoadingDetails = true;
  try {
    const domain = `${String(this.info?.domain?.name || '').trim()}${String(this.info?.identifier || '').trim()}`;
    const isLinkType = ['qrlink', 'clickyarseo'].includes(this.info?.type?.trim()?.toLowerCase());
    const endpoint = isLinkType
      ? `/v1/testQr/find1/${this.info?.qrId?.replace('?gateway=true', '')}`
      : `/v1/testQr/find/${domain}`;

    const { data } = await this.$api.get(endpoint);

    if (data?.data) {
      const resData = { ...data.data };

      if (typeof resData.domain === 'string') {
        resData.domain = { name: resData.domain };
      }

      if (resData.user_register !== undefined) await this.setRegisterOnline(resData.user_register);
      if (resData.id) await this.updateQrId(resData.id);
      if (resData.type) await this.setQrType(resData.type);

      // Object.assign(this.info, resData);
      // this.$set(this.info, '_detailsLoaded', true);
        const nextInfo = {
          ...this.info,
          ...resData,
          _detailsLoaded: true
        }

        this.info = nextInfo

      this.showExpanded = true;
    }else
        this.showExpanded = false;

  } catch (error) {
    this.showExpanded = false;
    this.$toast.error(error?.response?.data?.message || "دریافت اطلاعات کیوآر با خطا مواجه شد");
  } finally {
    this.isLoadingDetails = false;
  }
},

handleClick(event) {
    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }},

    dragEvent(e) {
      if (!e) return;
      e.stopPropagation();
      e.preventDefault();
      let uploader = this.$refs.uploader;

      if (
        e.type === "dragover" &&
        !uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.add("drag-over");
      else if (
        e.type === "dragleave" &&
        uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.remove("drag-over");
      else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");
        const files = e.target.files || e.dataTransfer.files;
        if (
          files[0] &&
          files[0].type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          this.excelFile = files[0];
          this.handleFileUpload(files[0]);
        } else {
          this.$toast.error(
            this.$t("UPLOAD_EXCEL.INVALID_FILE_TYPE") ||
              "لطفاً فقط فایل اکسل (.xlsx) آپلود کنید",
          );
        }
      } else if (e.type === "click") {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".xlsx";
        input.onchange = (event) => {
          const file = event.target.files[0];
          if (
            file &&
            file.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            this.excelFile = file;
            this.handleFileUpload(file);
          } else {
            this.$toast.error(
              this.$t("UPLOAD_EXCEL.INVALID_FILE_TYPE") ||
                "لطفاً فقط فایل اکسل (.xlsx) آپلود کنید",
            );
          }
        };
        input.click();
      }
    },
    handleFileUpload(file) {
      if (file) {
        this.filesPreview = [{ name: file.name }];
        this.$forceUpdate();
      }
    },
    removeFileFromUpload() {
      this.filesPreview = [];
      this.excelFile = null;
      this.$forceUpdate();
    },
    async sendFile() {
      if (!this.excelFile || !this.authToken || !this.info.qrId) {
        this.$toast.error(
          this.$t("GENERAL.ERROR") || "خطا: فایل، توکن یا شناسه QR معتبر نیست",
        );
        return;
      }

      this.upLoading = true;
      const data = new FormData();
      data.append("file", this.excelFile);
      data.append("qr_id", this.info.id);
      console.log(this.excelFile, this.info.id, this.info, "values");

      try {
        const response = await this.$api.post(
          "/v1/testQr/importBShopQrProduct",
          data,
        );
        this.$toast.success(
          response.data?.message ||
            this.$t("GENERAL.SUCCESSFULLY_ADDED") ||
            "محصولات با موفقیت آپلود شد",
        );
        this.bshop_mang_pop = false;
        this.removeFileFromUpload();
        this.$emit("fetch");
      } catch (error) {
        console.error("Failed to import products:", error);
        const errorMsg =
          error.response?.data?.message ||
          this.$t("GENERAL.ERROR") ||
          "خطا در آپلود محصولات";
        this.$toast.error(errorMsg);
      } finally {
        this.upLoading = false;
      }
    },
    async downloadProducts() {
      if (!this.authToken || !this.info.qrId) {
        this.$toast.error(
          this.$t("GENERAL.ERROR") || "خطا: توکن یا شناسه QR معتبر نیست",
        );
        return;
      }

      this.downloadLoading = true;
      const params = {
        qr_id: this.info.id,
        lang: this.exportLang,
      };

      try {
        const response = await this.$api.get(
          "/v1/testQr/exportBShopQrProduct",
          {
            params,
            headers: {
              Authorization: `Bearer ${this.authToken}`,
            },
          },
        );

        if (response.data.status && response.data.data.url) {
          const url = response.data.data.url;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `bshop_products_${this.info.qrId?.replace('?gateway=true','')}.${this.exportLang}.xlsx`,
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.$toast.success(
            response.data.message ||
              this.$t("SUCCESSFULLY_DOWNLOADED") ||
              "محصولات با موفقیت دانلود شد",
          );
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error("Failed to export products:", error);
        const errorMsg =
          error.response?.data?.message ||
          this.$t("GENERAL.ERROR") ||
          "خطا در دانلود محصولات";
        this.$toast.error(errorMsg);
      } finally {
        this.downloadLoading = false;
      }
    },

    ///
    onImageLoad() {
      this.imageLoading = false;
    },
    onImageError() {
      this.imageLoading = false;
      this.imageHasError = true;
    },
    hasValidHelpinfo(elementName) {
      if (
        (!this.helpData ||
          !Array.isArray(this.helpData) ||
          this.helpData.length === 0) &&
        !this.ribbon_can("guideuser")
      ) {
        return false;
      }
      const itemElement = this.helpData?.find(
        (p) =>
          p.name &&
          typeof p.name === "string" &&
          p.name.trim() === (elementName?.trim() || ""),
      );
      return itemElement || this.ribbon_can("guideuser");
    },
    findEditPage(name, id, type, qrid) {
      qrid = qrid?.replace('?gateway=true','');
      console.log(qrid,type,"qrid")
      const types = {
        visitcard: `/qr/edit/${name}${!!id ? id : ""}`,
        visitcardpro: `/qr/editpro/${name}${!!id ? id : ""}`,
        business: `/qr/editBpage/${name}${!!id ? id : ""}`,
        goldlabel: `/qr/goldlabel/${name}${!!id ? id : ""}`,
        commericial: `/qr/editCpage/${name}${!!id ? id : ""}`,
        qrlink: `/qr/link/${!!qrid ? qrid : ""}`,
        clickyarseo: `/qr/linkpro/${!!qrid ? qrid : ""}`,
        socialmedia: `/qr/editSocial/${name}${!!id ? id : ""}`,
        consultationqr: `/qr/consultationQrEdit/${name}${!!id ? id : ""}`,
        videogallery: `/qr/editVideo/${name}${!!id ? id : ""}`,
        voicegallery: `/qr/editVoice/${name}${!!id ? id : ""}`,
        voicegallerypro: `/qr/editVoicePro/${name}${!!id ? id : ""}`,
        feedbackgallery: `/qr/editFeedback/${name}${!!id ? id : ""}`,
        photogallery: `/qr/editPhoto/${name}${!!id ? id : ""}`,
        singleproduct: `/qr/product/${name}${!!id ? id : ""}`,
        labelproduct: `/qr/labelproduct/${name}${!!id ? id : ""}`,
        menu: `/qr/editMenu/${name}${!!id ? id : ""}`,
        bshop: `/qr/editBShop/${name}${!!id ? id : ""}`,
        appointment: `/qr/editAppointment/${name}${!!id ? id : ""}`,
        application: `/qr/editApplication/${name}${!!id ? id : ""}`,
        insurance: `/qr/insurance/${name}${!!id ? id : ""}`,
        wheel: `/qr/luck-wheel/${name}${!!id ? id : ""}`,
        multicard: `/qr/multicard/${name}${!!id ? id : ""}`,
        productpro: `/qr/productPro/${name}${!!id ? id : ""}`,
        pdfgallery: `/qr/editPdf/${name}${!!id ? id : ""}`,
        catalog: `/qr/editcatalog/${name}${!!id ? id : ""}`,
        gift:`/qr/editgift/${name}${!!id ? id : ""}`,
        text:`/qr/editText/${name}${!!id ? id : ""}`,
        qrbale:`/qr/editBale/${name}${!!id ? id : ""}`,
        qrrobika:`/qr/editRobika/${name}${!!id ? id : ""}`,
        qreitaa:`/qr/editEitaa/${name}${!!id ? id : ""}`,
        bankcard:`/qr/bankcard/${name}${!!id ? id : ""}`,
        pricelabel: `/qr/labelprice/${name}${!!id ? id : ""}`,
        attendanceqr: `/qr/editattendance/${name}${!!id ? id : ""}`,     


      };
      const excludedTypes = ['attendanceqr', 'bankcard','pricelabel','qrbale','qrrobika','qreitaa','text','consultationqr','appointment','application','wheel','labelproduct','bshop','insurance','multicard','feedbackgallery','singleproduct','voicegallerypro','catalog','voicegallery','productpro','commericial','goldlabel','visitcard', 'visitcardpro', 'gift',"videogallery", "socialmedia", "photogallery","pdfgallery","menu", "business"];
      if (!excludedTypes.includes(type?.trim()?.toLowerCase())) {
      return types[type?.toLowerCase()]?.replace('?gateway=true','');
      }
      return `${types[type?.toLowerCase()]?.replace('?gateway=true','')}?gateway=true`;
      // this.goto(types[type]);
    },
    copyUrl() {
      if (["qrLink","clickyarseo"].includes(this.info.type)) {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(this.info?.dest_link)
            .then(() => {
              this.showTooltip = true;
            })
            .catch((err) => {
              console.error("Clipboard error:", err);
            });
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = this.info?.dest_link;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
          this.showTooltip = true;
        }
      } else if (this.info.domain) {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(this.qrLink)
            .then(() => {
              this.showTooltip = true;
            })
            .catch((err) => {
              console.error("Clipboard error:", err);
            });
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = this.qrLink;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
          this.showTooltip = true;
        }
      }
    },
    onCloseField() {
      this.errorMessage = null;
      this.editTitle = false;
    },
    updateTitle() {
      if (!this.editedName || this.editedName.length <= 0) {
        this.errorMessage = "نام کارت ویزیت را به درستی وارد نمایید!";
        return;
      }
      if (this.info.title === this.editedName) 
      return;

      this.loading = true;
      this.$api
        .put(
          "/v1/testQr/update",
          ["qrLink","clickyarseo"].includes(this.info?.type?.trim())
            ? {
                qr_id: this.info?.qrId,
                title: this.editedName,
                type:this.info?.type?.trim(),
              }
            : {
                qr_id: this.info?.qrId,
                domain: this.info?.domain?.name || "qrland.in",
                identifier: this.info?.identifier || "",
                title: this.editedName,
              },
        )
        .then(({ data }) => {
          this.onCloseField();
          this.info.title = this.editedName;
        })
        .finally(() => (this.loading = false));
    },

    async showDestroy() {
      if (await this.$modal.yesNo("آیا از حذف کیوآر مطمئن هستید؟")) {
        this.destroy();
      }
    },
    destroy() {
      this.loading = true;

      this.$api
        .delete(`/v1/testQr/delete`, {
          params:
          ["qrLink","clickyarseo"].includes(this.info?.type?.trim())              ? {
                  qr_id: this.info?.id,
                }
              : {
                  domain: this.info.domain?.name || "",
                  identifier: this.info?.identifier || "",
                },
        })
        .then(({ data }) => {
          this.$toast.success("کیوآر با موفقیت حذف شد.");
          this.$emit("fetch");
        })
        .catch(({ response }) => console.log("error in delete qr: ", response))
        .finally(() => (this.loading = false));
    },

    async showPause(input) {
      let msg =
        input === "deactivate"
          ? "آیا از متوقف کردن کیوآر مطمئن هستید؟"
          : "آیا از فعال کردن کیوآر مطمئن هستید؟";
      if (await this.$modal.yesNo(msg)) {
        this.disable(input);
      }
    },
    disable(input) {
      this.loading = true;

      this.$api
        .put(
          "/v1/testQr/update",
          ["qrLink","clickyarseo"].includes(this.info?.type?.trim())
            ? {
                qr_id: this.info.qrId,
                status: input,
              }
            : {
                qr_id: this.info.qrId,
                domain: this.info.domain?.name || "",
                identifier: this.info.identifier || "",
                status: input,
              },
        )
        .then(({ data }) => {
          let s = { active: "فعال", deactivate: "متوقف" };
          this.$toast.success(`کیوآر با موفقیت ${s[input]} شد.`);
          this.$emit("fetch");
        })
        .catch(({ response }) => console.log("error in paused qr: ", response))
        .finally(() => (this.loading = false));
    },

    getPrices() {
      this.$root.$emit("getPrices", this.info);
    },
    transferUser(e) {
      this.loading = true;

      this.$api
        .put(
          "/admin/transfer-qr",
          {},
          {
            params: {
              qr: this.info.id,
              user: e,
            },
          },
        )
        .then(({ data }) => {
          if (
            data &&
            data.status &&
            (data.status === true || data.status === "200")
          ) {
            this.$toast.success("کاربر با موفقیت انتقال یافت");
            this.$refs.userPicker.dialog = false;
          } else {
            this.$toast.error("مشکلی در انتقال رخ داده است!");
          }
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در انتقال کاربر!");
        })
        .finally(() => (this.loading = false));
    },
    qrUpdate(final = false) {
      this.loading = true;

      const data = new FormData();
      data.append("domain", this.info?.domain?.name);
      data.append("identifier", this.info.identifier || "");
      data.append("_method", "PUT");
      data.append("image", this.qrSvgDataUrl);
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append("qr_id", this.info.qrId);

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          this.finish = final;
          this.goto("qr/list");
          this.$toast.success("کیوآر شما باموفقیت ویرایش شد.");
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    Participation() {
      let type = this.info?.type?.toLowerCase();
      this.$api
        .get(
          type === "commericial"
            ? `${this.$qrApi}/v1/commercial/${this.info.id}`
            : `${this.$qrApi}/v1/commercial/user?qr=${this.info.id}`,
        )
        .then(({ data }) => {});
    },
    choseNfc() {
      return true;
    },
  },
};
</script>

<style scoped>
.custom-link-chip {
  background-color: #01176610 !important; /* آبی بسیار کمرنگ */
  border: 1px solid #042ec846 !important; /* بوردر 1 پیکسل سرمه‌ای */
  color: #042FC8 !important;
}

.responsive-renew-btn {
  width: 99% !important;
  max-width: 100% !important;
}

.v-card {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 1px;
}
.modern-list-item {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid #e0e0e0 !important;
}

.gradient-border-wrapper {
  padding: 3px;
  width: 45px;
  height: 45px;
}

.gradient-icon {
  -webkit-background-clip: text !important;
  background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
  display: flex;
}

.gradient-text {
  -webkit-background-clip: text !important;
  background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  filter: drop-shadow(0px 1px 1px rgba(0,0,0,0.1));
}

.gap-1 { gap: 4px; }
.gap-2 { gap: 8px; }
.min-width-200 { min-width: 200px; }

/* اصلاحات مخصوص موبایل */
@media (max-width: 959px) {
  .w-100-mobile {
    width: 100%;
    margin-top: 8px;
  }
}
.btn-mang{
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
  min-height: 40px !important;
}
/* ظرف اصلی کارت */
.qr-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  overflow: hidden;
}

.qr-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1) !important;
}

/* هدر کلیک‌پذیر */
.card-header-clickable {
  cursor: pointer;
  user-select: none;
  transition: background 0.2s;
}

.card-header-clickable:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

/* تصویر Thumbnail در حالت بسته */
.qr-thumb-container {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #eee;
  background: #f9f9f9;
}

.qr-thumb {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* استایل متون */
.qr-title {
  font-size: 1rem;
  font-weight: 700;
  color: #2c3e50;
}

.qr-subtitle {
  font-size: 0.8rem;
  color: #7f8c8d;
}

/* بخش آمار در دسکتاپ */
.stat-item {
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  border-radius: 10px;
  background: #f8fafc;
  min-width: 100px;
}

.stat-label {
  font-size: 0.7rem;
  color: #64748b;
}

.stat-value {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
}

/* شبکه ابزارها (Tools Grid) */
.tools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 12px;
  padding: 16px;
}

.tool-btn {
  display: flex !important;
  flex-direction: column !important;
  height: auto !important;
  padding: 12px 8px !important;
  border-radius: 16px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  transition: all 0.2s !important;
}

.tool-btn:hover:not(.v-btn--disabled) {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.tool-icon-wrapper {
  margin-bottom: 8px;
}

.tool-label {
  font-size: 0.75rem !important;
  font-weight: 600;
  line-height: 1.2;
  white-space: normal;
  text-align: center;
}

/* نمایش QR در حالت باز */
.qr-expanded-container {
  background: #ffffff;
  border-radius: 20px;
  padding: 10px;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.05);
}

.qr-image-main {
  width: 100%;
  max-width: 220px;
  height: auto;
  border-radius: 12px;
}

/* استایل مخصوص موبایل */
@media (max-width: 600px) {
  .tools-grid {
    grid-template-columns: repeat(3, 1fr); 
    gap: 8px;
    padding: 8px;
  }
  
  .tool-btn {
    padding: 8px 4px !important;
  }
  
  .tool-label {
    font-size: 0.65rem !important;
  }

  .mobile-meta-row {
    background: #f1f5f9;
    border-radius: 12px;
    margin: 10px 0;
  }
}

.footer-actions {
  border-top: 1px border #eee;
  padding-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.v-btn--disabled .tool-label {
  color: rgba(0, 0, 0, 0.26) !important;
}
.inner-icon-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tools-grid-container {
  display: flex !important;
  flex-wrap: wrap !important; 
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}

.tool-btn {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  border-width: 1px !important;
  text-transform: none !important;
}
.tool-btn .v-icon {
  margin-bottom: 4px;
  font-size: 20px !important;
}

.tool-label {
  font-size: 10px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

@media (max-width: 599px) {
  .tools-grid-container {
    grid-template-columns: repeat(3, 1fr); /* 3 ستون در موبایل */
    gap: 6px;
  }
  
  .tool-btn {
    height: 64px !important;
  }
  
  .tool-label {
    font-size: 9px;
  }
}
/* تنظیمات عمومی دکمه‌های ابزار */
.tool-btn {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  border-width: 1px !important;
  text-transform: none !important;
  
}

/* در حالت دسکتاپ: بدون متن، آیکون‌ها بزرگتر، ساختار مربعی و فشرده‌تر */
@media (min-width: 426px) {
    .responsive-renew-btn {
    width: fit-content !important;
    max-width: fit-content !important;
  }

  .tools-grid-container {
    display: grid;
    grid-template-columns: repeat(6, 1fr); 
    gap: 8px;
    width: 100%;
  }
  
 .tool-label {
    display: none !important; 
  }
  
  .tool-btn {
    height: 48px !important;
    width: 48px !important;
    min-width: 48px !important;
    padding: 0 !important;
    margin: 0 !important;
    
  }

  .tool-btn .v-icon {
    font-size: 24px !important;
    margin: 0 !important;
  }
}

/* در حالت موبایل/تبلت: همراه با متن، تعداد ستون کمتر */
@media (max-width: 959px) {
  .tools-grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* 3 ستون در موبایل */
    gap: 6px;
    width: 100%;
  }

  .tool-btn {
    height: 64px !important;
    padding: 8px !important;
  }

  .tool-btn .v-icon {
    margin-bottom: 4px !important;
    font-size: 20px !important;
  }

  .tool-label {
    display: block;
    font-size: 9px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
}
/* در حالت موبایل/تبلت */
@media (max-width: 959px) {
  .tool-btn {
    width: calc(50% - 4px) !important; 
    flex: 0 0 calc(50% - 4px) !important; 
    height: auto !important; 
    min-height: 56px !important;
    padding: 12px 4px !important;
  }

  .tool-btn .v-btn__content {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    white-space: normal !important; 
  }

  .tool-btn .v-icon {
    margin-bottom: 8px !important;
    font-size: 24px !important;
  }

  .tool-label {
    display: block !important;
    font-size: 11px;
    line-height: 1.4;
    white-space: normal !important; 
    word-wrap: break-word;
    word-break: break-word !important;
    text-align: center;
    width: 100% !important;
  }
}
  @media (max-width: 376px) {
 .tool-btn {
    width: calc(50% - 4px) !important;
  }
  }
@media (min-width: 375px) and (max-width: 425px) {
  .tool-btn {
    width: calc(33.333% - 4px) !important; 
    flex: 0 0 calc(33.333% - 4px) !important; 
    max-width: calc(33.333% - 4px) !important;
  }
}
@media (min-width: 425px) and (max-width: 759px) {
  .tool-btn {
    width: calc(25% - 5px) !important; 
    flex: 0 0 calc(25% - 5px) !important; 
    max-width: calc(25% - 5px) !important;
  }}
@media (min-width: 760px) and (max-width: 1022px) {
  .tool-btn {
    width: calc(20% - 5px) !important; 
    flex: 0 0 calc(20% - 5px) !important; 
    max-width: calc(20% - 5px) !important;
  }
}
@media (max-width: 370px) {
  .main-qr-title {
    white-space: normal !important;
    word-break: break-word !important;
    max-width: 160px !important;
    display: block !important;
    line-height: 1.4;
  }

  .tool-label {
    font-size: 9px !important;
  }
}

@media (min-width: 371px) {
  .main-qr-title {
    max-width: 300px !important;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.status-dates {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 8px;
}

.status-dates .d-flex {
  margin-bottom: 6px;
}
.hover-elevation {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

.hover-elevation:hover {
  elevation: 10 !important;           /* Vuetify elevation */
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14) !important;
  transform: translateY(-4px);
  z-index: 3;
}

/* برای سازگاری بیشتر با Vuetify */
.v-card.hover-elevation:hover {
  box-shadow: 0 12px 28px -6px rgba(0, 0, 0, 0.18) !important;
}
</style>
